"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const is_prop_valid_1 = __importDefault(require("@emotion/is-prop-valid"));
const styled_1 = __importDefault(require("@emotion/styled"));
const StyledMenuList_1 = __importDefault(require("../Select/StyledMenuList"));
const StyledListWrapper = (0, styled_1.default)(StyledMenuList_1.default.withComponent('div'), {
    shouldForwardProp: (prop) => (0, is_prop_valid_1.default)(prop) && !['onSelectValue', 'value'].includes(prop)
})({
    'width': 'auto',
    'paddingLeft': 9,
    'overflowY': 'unset',
    '@-moz-document url-prefix()': {
        paddingRight: 5
    }
});
exports.default = StyledListWrapper;
//# sourceMappingURL=StyledListWrapper.js.map